export default "__VITE_ASSET__30449a34__"